<template>
	<div class="energy">
		<div class="title">
			<img src="../../../assets/img/logo.png" alt="">
			<span>能耗统计</span>
		</div>
		<div class="energybox">
			<div class="energyboxecharts1">
				<div id="echarts1">
					<div id="echarts1_box"></div>
				</div>
				<p>
					<h5>42003.1<span>KW</span></h5>
					<h6>累计耗电总量</h6>
				</p>
			</div>
			<div class="energybox_fg"></div>
			<div class="energyboxecharts1">
				<div id="echarts2">
					<div id="echarts2_box"></div>
				</div>
				<p>
					<h5>32003.1<span>m³</span></h5>
					<h6>累计用水总量</h6>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
	  	return{
			data:[1]
		}
	  },
	  methods: {
		  fontSize(res,initWidth=1920){
		  					var nowClientWidth = document.documentElement.clientWidth;
		  					return res*(nowClientWidth/initWidth);
		  				},
		  // echartsLine(){
			 //  var echarts = require('echarts');
			 //  let energyConsumption = echarts.init(document.getElementById('echarts1_box'));
			 //   energyConsumption.setOption({
				//        series: [
				//            {
				//                type: 'pie',
				// 			   startAngle: 0,
				//                radius: ['50%', '70%'],
				// 			   center:['50%','50%'],
				//                avoidLabelOverlap: false,
				//                color:['#7ae8fb', '#04297a'],
				//                label: {
				//                    show: false,
				//                    position: 'center'
				//                },
				//                emphasis: {
				//                    label: {
				//                        show: true,
				//                        fontSize: '40',
				//                        fontWeight: 'bold'
				//                    }
				//                },
				//                labelLine: {
				//                    show: false
				//                },
				// 			   emphasis: {
				// 			         scale: false
				// 			   },
				//                data: [5,3]
				//            },
				// 		   {
				// 		       type: "gauge",
				// 			   center:['50%','50%'],
				// 			    radius: "100%",
				// 				z:9,
				// 		       detail: {
				// 		         show: false
				// 		       },
				// 			   data:[1],
				// 		       axisLine: {
				// 		         show: false
				// 		       },
				// 		       progress: {
				// 		         show: false
				// 		       },
				// 		       axisTick: {
				// 		         show: false,
				// 				  distance: 0,
				// 		       },
				// 		       axisLabel: {
				// 		         show: false
				// 		       },
				// 		       pointer: {
				// 		         show: false
				// 		       },
				// 		       anchor: {},
				// 		       title: {
				// 		         show: false
				// 		       },
				// 		       startAngle: 0,
				// 		       endAngle: 360,
				// 		       clockwise: true,
				// 		       splitNumber: 30,
				// 		       splitLine: {
				// 		         length: '24%',
				// 				 distance:this.fontSize(5),
				// 		         lineStyle: {
				// 		           width: this.fontSize(2),
				// 		           color: "#25394b"
				// 				   //"#25394b",
						           
				// 		         }
				// 		       }
				// 		     }
				//        ]
				//    }
			 //   )
			 //   window.addEventListener("resize", () => {
			 //     energyConsumption.resize();
			 //   });
		  // },
		  // echartsLine1(){
		  // 			  var echarts = require('echarts');
		  // 			  let energyConsumption = echarts.init(document.getElementById('echarts2_box'));
		  // 			   energyConsumption.setOption({
		  					  
		  // 				       series: [
		  // 				           {
		  // 				               type: 'pie',
		  // 				               radius: ['50%', '70%'],
		  // 							   center:['50%','50%'],
				// 					   startAngle: 0,
				// 						emphasis: {
				// 						      scale: false
				// 						    },
		  // 				               avoidLabelOverlap: false,
		  // 				               color:['#7ae8fb', '#04297a'],
		  // 				               label: {
		  // 				                   show: false,
		  // 				                   position: 'center'
		  // 				               },
		  // 				               emphasis: {
		  // 				                   label: {
		  // 				                       show: true,
		  // 				                       fontSize: '40',
		  // 				                       fontWeight: 'bold'
		  // 				                   }
		  // 				               },
		  // 				               labelLine: {
		  // 				                   show: false
		  // 				               },
				// 					   emphasis: {
				// 					         scale: false
				// 					   },
		  // 				               data: [4,1]
		  // 				           },
		  // 						   {
		  // 						       type: "gauge",
		  // 							   center:['50%','50%'],
		  // 							    radius: "100%",
		  // 								z:9,
		  // 						       detail: {
		  // 						         show: false
		  // 						       },
		  // 						       data: [{
		  // 						         value: 50,
		  // 						         name: "Percent"
		  // 						       }],
		  // 						       axisLine: {
		  // 						         show: false
		  // 						       },
		  // 						       progress: {
		  // 						         show: false
		  // 						       },
		  // 						       axisTick: {
		  // 						         show: false,
		  // 								  distance: 0,
		  // 						       },
		  // 						       axisLabel: {
		  // 						         show: false
		  // 						       },
		  // 						       pointer: {
		  // 						         show: false
		  // 						       },
		  // 						       anchor: {},
		  // 						       title: {
		  // 						         show: false
		  // 						       },
		  // 						       startAngle: 0,
		  // 						       endAngle: 360,
		  // 						       clockwise: true,
		  // 						       splitNumber: 30,
		  // 						       splitLine: {
		  // 						        length: '24%',
		  // 						        distance:this.fontSize(6),
		  // 						         lineStyle: {
		  // 						           width: this.fontSize(2),
		  // 						           color: "#4d6275",
		  						           
		  // 						         }
		  // 						       }
		  // 						     }
		  // 				       ]
		  // 				   }
		  // 			   )
				// 	   window.addEventListener("resize", () => {
				// 	     energyConsumption.resize();
				// 	   });
		  // }
	  },
	  mounted() {
		  // window.addEventListener("resize", () => {
		  //    this.echartsLine();
		  // });
		  // this.echartsLine()
		  // this.echartsLine1()
	  }
	};
</script>

<style scoped="scoped">
	.energy{
		width: 100%;
		height: 26.5%;
		
	}
	.energybox{
		width: 100%;
		height: calc(100% - 4vh);
		box-sizing: border-box;
		padding: 5% 0 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.energybox>div{
		height: 100%;
	}
	.energyboxecharts1{
		position: relative;
		width: 40%;
		margin: 0 5px;
	}
	.energyboxecharts1>div{
		width: 100%;
		height: 70%;
		position: relative;
	}
	#echarts1{
		background: url(../../../assets/img/1.png) no-repeat;
		background-position: center center; 
		background-size: 80% auto;
	}
	#echarts2{
		background: url(../../../assets/img/2.png) no-repeat;
		background-position: center center;
		background-size: 80% auto;
		/* transform-style:preserve-3d;
		 transform: scale(1.5);
		 perspective: 1000px; */
	}
	/* #echarts1_box{
		position: absolute;
		width: 100%;
		height: 100%;
		transform:rotateX(63deg);
		transform-origin: 50% 58%;
		
	}
	#echarts2_box{
		position: absolute;
		width: 100%;
		height: 100%;
		transform:rotateX(63deg);
		transform-origin: 50% 58%;
	} */
	.energyboxecharts1>p{
		position: absolute;
		left: 0;
		bottom: 0;
		text-align: center;
		box-sizing: border-box;
		padding-top: 5%;
		padding-bottom: 5%;
		width: 100%;
	}
	.energyboxecharts1>p h5{
		font-weight: 400;
		color: #27CAFF;
		font-family: 'ruil';
		font-size: .8vw;
	}
	.energyboxecharts1>p h5 span{
		color: #FFFFFF;
	}
	.energyboxecharts1>p h6{
		font-weight: 400;
		color: #FFFFFF;
		 font-size: .6vw;

	}
	.energybox_fg{
		width: 2%;
		height: 100%;
		background: url(../../../assets/img/energyfgx.png) no-repeat;
		background-position: center 80%;
	}
</style>
